import { useEffect, useState } from "react";
import recentSearches from "../../apis/recentSearches";
import { useAuthContext } from "../../context/AuthContext";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import BlockHeader from "../Headers/BlockHeader";
import { AlertInfo } from "../Alerts/Alert";
import ComponentLoader from "../Loader/ComponentLoader";

const RecentSearches = () => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(false);

  useEffect(() => {
    if (user_slug !== undefined) {
      getRecentSearches();
    }
  }, [user_slug]);

  const getRecentSearches = () => {
    Promise.all([recentSearches(user_slug)])
      .then(async ([data]) => {
        if (data?.data?.status === 1) {
          setIsLoading(false);
          setData(data?.data?.result);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const displayLoader = () => {
    return (
      <div className="d-flex p-3 justify-content-center align-items-center">
        <div className="spinner-border" role="status" />
      </div>
    );
  };

  const displayKeyword = (keyword) => {
    if (keyword !== null && keyword !== "") {
      return <span className="text-dark">{keyword}</span>;
    } else {
      return <span className="text-secondary">Not specified</span>;
    }
  };

  const displayList = () => {
    return (
      <div className="table-responsive table-wrapper scrollable">
        <table className="table table-bordered">
          <thead className="no-border">
            <tr className="border-top-0">
              <th>Keyword</th>
              <th>Location</th>
              <th className="">Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index.toString()}>
                <td className="align-middle">{displayKeyword(item.keyword)}</td>
                <td className="align-middle">
                  {displayKeyword(item.location)}
                </td>
                <td className="">
                  <Button variant="primary" size="sm">
                    Search
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const displayContent = () => {
    if (!data) {
      return <AlertInfo message="Nothing to display here!" />;
    } else {
      return displayList();
    }
  };

  const checkIsLoading = () => {
    if (isLoading) {
      return <ComponentLoader />;
    } else {
      return displayContent();
    }
  };

  return (
    <div class="card">
      <div className="card-body">
        <BlockHeader
          title={"Recent Searches"}
          subText={"Last 10 search criteria"}
        />

        {checkIsLoading()}
      </div>
    </div>
  );
};

export default RecentSearches;
